import * as React from 'react';
import { Layout, Row } from 'antd';
import styled from 'styled-components';
import ScreenHelper from '../../Styled/ScreenHelper';
import logoSvg from '../../../assets/images/logo.png';
import loginBackground from '../../../assets/images/VMIPO_Login.jpg';
import forgetPasswordBackground from '../../../assets/images/VMIPO_ForgetPassword.jpg';

const { Header, Content, Footer } = Layout;

export const CenteredContent = styled(Content)`
  height: 100%;
  min-height: 60vh;
  margin-bottom:170px;

  ${ScreenHelper.down('md')} {
    padding-top: 1vh;
  }

  ${ScreenHelper.up('md')} {
    padding-top: 15vh;
  }
`;

export const ForgetPasswordWithBackground = styled(Layout)`
    background: url(${forgetPasswordBackground});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-height:100vh;
`;


export const LoginWithBackground = styled(Layout)`
    background: url(${loginBackground});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-height:100vh;
`;

export const LoginContent = styled.div`
  background-color: white;
  padding: 20px 40px 10px 40px;
`;

export const MainLogo = styled.div`
  height: 9em;
  /*width: 21em;*/

  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  border: none;
  background: url(${logoSvg});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${ScreenHelper.down('sm')} {
    height: 8em;
    width: 10em;
  }
`;






